// extracted by mini-css-extract-plugin
export default {"stroke":"styles_stroke__ckvWW","active":"styles_active__N2UMH","activeStroke":"styles_activeStroke__7nuiJ"};